/**
 * Common footer for list pages: Prev | Page X of Y | Next.
 * Hidden when `show` is false (no data at all). Paging is clamped to 1..totalPages.
 */
const ListPagination = ({ pageNo, totalPages, onPageChange, show = true }) => {
  if (!show) return null;
  const lastPage = Math.max(totalPages || 1, 1);

  return (
    <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2">
      <button
        type="button"
        className="btn btn-outline-custom btn-sm"
        onClick={() => onPageChange(Math.max(pageNo - 1, 1))}
        disabled={pageNo <= 1}
      >
        Prev
      </button>
      <span className="mx-2">
        Page {pageNo} of {lastPage}
      </span>
      <button
        type="button"
        className="btn btn-outline-custom btn-sm"
        onClick={() => onPageChange(Math.min(pageNo + 1, lastPage))}
        disabled={pageNo >= lastPage}
      >
        Next
      </button>
    </div>
  );
};

export default ListPagination;
